<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab :to="{ name: 'member-dashboard' }" ripple>{{ $t('member_dashboard') }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentView: 'member-dashboard'
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Juzmatch/AdminMenu.vue